module.exports = __webpack_public_path__ + "static/media/alpecin.3a8b62a9.png";